import React, { Component } from "react";
import Config from "../../../Config";
import "./app_card_status.css";

export default class app_card_status extends Component {
  render() {
    return this.props.status ? (
      <div
        className={`card-status-container `}
        style={{border:this.props.showBorder==true ? "1px solid #808EA8" :""}}
        /* style={{
          backgroundColor: `${
            Config[this.props.module].statusMapping[this.props.status]?.color || "black"
          }`,
        }} */
      >
        <div className="card-status-title">
          {Config[this.props.module].statusMapping[this.props.status]?.label || ""}
        </div>
      </div>
    ) : null;
  }
}
